export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Учетные формы: Паспорт архивохранилища",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
